/* eslint-disable @typescript-eslint/no-explicit-any */

export class Csv {
  /**
   * It takes an array of objects, and returns a CSV file with the keys as the
   * header row
   * @param {any[]} json - any[] - The JSON data you want to convert to CSV.
   * @param [delimiter=,] - The delimiter to use. Default is a comma.
   * @param {string} [name] - The name of the file.
   */
  static fromJSON(json: any[], delimiter = ',', name?: string) {
    const items = json.map((obj) => Csv.flattenObject(obj));
    const filename = name || Date.now() + '-data.csv';

    const header = Array.from(
      new Set(items.reduce((r: any, e: any) => [...r, ...Object.keys(e)], []))
    );

    let csv: any = items.map((row: any) =>
      header.map((h: any) => JSON.stringify(row[h])).join(delimiter)
    );

    csv.unshift(header.join(delimiter));

    csv = csv.join('\r\n');

    const blob = new Blob([csv], {
      type: 'text/plain;charset=utf-8',
    });

    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  /**
   * It takes an object and returns a new object with all the nested objects
   * flattened
   * @param {any} object - The object you want to flatten.
   * @returns An object with all the keys and values of the original object, but
   * with the keys flattened.
   */
  static flattenObject(object: any) {
    const result: any = {};

    for (const i in object) {
      if (typeof object[i] === 'object') {
        const temp = Csv.flattenObject(object[i]);
        for (const j in temp) {
          result[i + j] = temp[j];
        }
      } else {
        result[i] = object[i];
      }
    }
    return result;
  }
}
